
export { HorizontalProductCardSkeleton } from "/codebuild/output/src2176744316/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src2176744316/src/packages/shared-components/src/components/ProductCard/index.ts"